import { notify } from '../../actions/notifications';
import { removeSavedSearches } from '../../actions/savedSearches/actions';
import {
  TWebDeleteSavedSearchesResponse,
  fetchWebDeleteSavedSearches,
} from '../../repositories/saved-searches/v1/web/delete-saved-searches';
import { ENotificationStyle } from '../../types/notifications';
import { TThunkAction } from '../../types/redux';

export const deleteSavedSearches =
  (id: number): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const showError = () => dispatch(notify('Не удалось удалить удалить поиск', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TWebDeleteSavedSearchesResponse = await fetchWebDeleteSavedSearches({
        httpApi,
        parameters: { savedSearchIds: [id] },
      });

      if (statusCode === 200) {
        dispatch(removeSavedSearches({ ids: [id] }));
      }

      if (statusCode === 400) {
        showError();
        logger.warning(response.message || 'Failed remove user save searche (400 status code)');
      }
    } catch (e) {
      showError();
      logger.error(e, { description: 'Failed remove user save searche' });
    }
  };
